import { PendenciaFechamentoCaixa } from '../domain/pendencia-fechamento-caixa.model';
import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';

export class PendenciaFechamentoCaixaSerializer extends DomainSerializer<PendenciaFechamentoCaixa> {}
